<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <b-row class="mx-0 mb-3">
      <b-col lg="12">
        <b-card title="Commissions Négociateurs" class=" bg-light shadow">
          <b-row>
            <b-col lg="3">
              <label>Sélectionnez un nego</label>
              <b-select
                class="mb-3"
                v-model="negoSelected"
                :options="negosOptions"
                @change="loadCommissions(negoSelected)"
              ></b-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-card
                class="mb-3"
                header-tag="h6"
                header-text-variant="light"
                bg-variant="secondary"
                header="Liste des commissions dues"
              >
                <div
                  v-for="(commission, index) in lazy(commissions)"
                  :key="index"
                >
                  <h5 class="text-center">
                    {{ toMonth(commission.month) }}
                  </h5>
                  <b-table
                    striped
                    hover
                    :items="commission.payements"
                    :fields="commission_fields"
                  >
                    <template v-slot:cell(creancier)="data">
                      <b-link
                        :to="{
                          name: 'creditorView',
                          params: { id: data.item.creancierID },
                        }"
                      >
                        {{ data.item.creancier }}
                      </b-link>
                    </template>
                    <template v-slot:cell(ID)="data">
                      <a href="#" @click.prevent="editInvoice(data.item)">
                        {{ data.item.ID }}
                      </a>
                    </template>
                    <template v-slot:bottom-row>
                      <td />
                      <td />
                      <td />
                      <td />
                      <td>
                        <strong
                          >Total :<span class="float-right"
                            >{{
                              Number(totalHTVA(commission)).toLocaleString(
                                undefined,
                                {
                                  minimumFractionDigits: 2,
                                }
                              )
                            }}
                            €</span
                          ></strong
                        >
                      </td>
                      <td />

                      <td>
                        <strong
                          ><span class="float-right"
                            >{{
                              Number(
                                totalCommission(commission)
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                              })
                            }}
                            €</span
                          ></strong
                        >
                      </td>
                      <td>
                        <strong
                          ><span class="float-right"
                            >{{
                              Number(totalSolde(commission)).toLocaleString(
                                undefined,
                                {
                                  minimumFractionDigits: 2,
                                }
                              )
                            }}
                            €</span
                          ></strong
                        >
                      </td>
                    </template>
                  </b-table>
                  <hr />
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import sellers from "@/services/sellers.js";
import negotiators from "@/services/negotiators.js";
import DateTime from "@/services/DateTime.js";
export default {
  name: "CommissionsNego",
  components: {
  },
  created() {
    this.loadCommissions(this.negoSelected);
    this.scroll();
  },
  methods: {
    totalHTVA(commission) {
      let total = 0;
      (commission.factures || []).forEach((el) => {
        total += Number(el.prixHTVA);
      });
      return total;
    },
    totalCommission(commission) {
      let total = 0;
      (commission.factures || []).forEach((item) => {
        total += Number(
          item.prixHTVA *
            Number(
              item.nego_commission == "0.00"
                ? item.vc / 100
                : item.nego_commission / 100
            )
        );
      });
      return total;
    },
    totalSolde(commission) {
      let total = 0;
      (commission.factures || []).forEach((el) => {
        total += Number(el.solde);
      });
      return total;
    },
    lazy(table) {
      return table.slice(0, this.nTables);
    },
    loadCommissions(id) {
      const param = id === null ? "all" : id;
      negotiators.commissions({ nego_id: param }).then((response) => {
        if (response.data.status == "success") {
          this.commissions = response.data.data.commissions;
          this.negosOptions = [
            {
              value: null,
              text: "Tous les negos",
            },
            ...response.data.data.negos,
          ];
        }
      });
    },
    
    
    scroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight + 300 >
          document.documentElement.offsetHeight;
        //console.log(document.documentElement.scrollTop + window.innerHeight, document.documentElement.offsetHeight);
        if (bottomOfWindow) {
          if (this.nTables < this.commissions.length) {
            this.nTables++;
          }
        }
      };
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    toMonth(d) {
      return DateTime.humanMonth(d);
    },
  },
  data() {
    return {
      Api: sellers,
      seller_id: null,
      invoice_id: null,
      commissions: [],
      nTables: 5,
      negosOptions: [],
      negoSelected: null,
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Administration",
          to: { name: "administration" },
        },
        {
          text: "Commission négociateurs",
          active: true,
        },
      ],
      
      commission_fields: [
        {
          key: "ID",
          label: "Numéro",
          class: "text-center",
        },
        {
          key: "nego_nom",
          label: "nego",
          sortable: true,
          formatter: (value, key, item) => {
            return item.nego_prenom + " " + item.nego_nom;
          },
        },

        {
          key: "date",
          label: "Date",
          class: "text-center",
          formatter: (value) => this.toDate(value),
        },
        {
          key: "creancier",
          label: "Créancier",
        },
        {
          key: "prixHTVA",
          label: "Prix HTVA",
          class: "text-right",
          formatter: (value) => `${Number(value).toFixed(2)} €`,
        },
        {
          key: "nego_commission",
          label: "Comission",
          class: "text-right",
          formatter: (value, key, item) =>
            value == "0.00"
              ? `${Number(item.vc).toFixed(0)} %`
              : `${Number(value).toFixed(0)} %`,
        },
        {
          key: "comm",
          label: "Commission HTVA",
          class: "text-right",
          formatter: (value, key, item) =>
            `${Number(
              item.prixHTVA *
                Number(
                  item.nego_commission == "0.00"
                    ? item.vc / 100
                    : item.nego_commission / 100
                )
            ).toFixed(2)} €`,
        },
        {
          key: "solde",
          label: "Solde",
          class: "text-right",
          formatter: (value) => `${Number(value).toFixed(2)} €`,
        },
      ]
    };
  },
};
</script>

<style lang="scss" scoped>
</style>